export const FILTER_TYPES_KEYS = {
  Unit: 'U',
  Industry: 'I',
  Organization: 'O',
  OrgVsInd: 'OI'
};

export const APPRAISAL_COMPARISON_FILTER_TYPES = [
  { key: FILTER_TYPES_KEYS.Industry, value: 'Unit vs. Industry', showUnitLine: true },
  { key: FILTER_TYPES_KEYS.Organization, value: 'Unit vs. Organization', showUnitLine: true },
  { key: FILTER_TYPES_KEYS.OrgVsInd, value: 'Organization vs. Industry', showUnitLine: false }
];
